import { defineMessages } from 'react-intl';

type MessageKeys = 'showMoreButtonText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		showMoreButtonText: {
			id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
			defaultMessage: 'Show more',
			description: 'Clicking this button will load more items into the dropdown',
		},
	});

export default message;
